import { formatEventTimeRange } from '~/utils/format-event-times';

import { EventDetailsHeader } from './event-details-header';

interface EventWaiverDescriptionProps {
  gymName: string | null;
  name: string;
  freeEvent: boolean | null;
  startTime: string | null;
  endTime: string | null;
  date: string | null;
}

export function EventWaiverDescription({
  gymName,
  name,
  freeEvent,
  startTime,
  endTime,
  date,
}: EventWaiverDescriptionProps) {
  return (
    <>
      <p className="text-body2">
        To {freeEvent ? 'RSVP' : 'purchase tickets'} for this event, please review and sign the
        required waiver below.
      </p>
      <EventDetailsHeader
        eventName={name}
        date={date}
        timeRange={formatEventTimeRange(startTime, endTime)}
        gymName={gymName}
      />
    </>
  );
}
